import React, { Component } from "react";

import "./Tickets.css";
import Filter from "../Filter/Filter";

class Tickets extends Component {
    state = {
        tickets: null,
        count: 1000,
        page: 0,
        filters: null,
        total: null,
    };
    constructor(props) {
        super(props);
        this.request_data = this.request_data.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.on_page_change = this.on_page_change.bind(this);
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate(prevProps, prevState) {
        let { page, count, filters, tickets } = this.state;
        if (
            !tickets ||
            prevState.page !== page ||
            prevState.count !== count ||
            prevState.filters !== filters
        ) {
            this.request_data();
        }
    }

    on_page_change(page) {
        this.setState({ page });
    }

    request_data() {
        let { toast, connection } = this.props;
        let { filters, page, count } = this.state;
        connection
            .get_filtered_data("tickets", filters, null, count, true, page)
            .then((res) => {
                let { tickets, total, page } = res.data;

                this.setState({ tickets, total, page });
            })
            .catch((err) => {
                toast("خطا در دریافت تیکت ها", " خطای : " + err, " danger");
            });
    }

    onFilterChange(filters) {
        let statuses = [];
        filters.sent && statuses.push('"sent"') && delete filters.sent;
        filters.notPayed &&
            statuses.push('"notPayed"') &&
            delete filters.notPayed;
        filters.pending && statuses.push('"pending"') && delete filters.pending;
        statuses.length > 0 && (filters.status = `[${statuses.join(",")}]`);

        filters.search == "" && delete filters.search;

        (filters.notPrinted && (filters.printed = false)) ||
            (true && delete filters.notPrinted);

        this.setState({ filters });
    }

    render() {
        let { tickets } = this.state;
        return (
            <div className="TicketsContainer">
                <Filter
                    filters={[
                        { label: "پیام خوانده نشده", value: "newMessage" },
                        { label: "پاسخ داده نشده", value: "notAnswered" },
                    ]}
                    onFilterChange={this.onFilterChange}
                />
                <div className="ticketsWraper">
                    {tickets &&
                        tickets.length > 0 &&
                        tickets.map((t) => {
                            let poster =
                                t.messages[t.messages.length - 1].poster;
                            return (
                                <div
                                    className={
                                        "ticketRow " +
                                        (t.newMessage && "newMessage")
                                    }
                                    key={t.id}
                                >
                                    <div className="lastMessage">
                                        <div className="poster text mate">
                                            {poster === "costumer"
                                                ? "مشتری  : "
                                                : "شما : "}
                                        </div>
                                        <div className="message">
                                            {
                                                t.messages[
                                                    t.messages.length - 1
                                                ].message
                                            }
                                        </div>
                                    </div>
                                    <div className="newMessage">
                                        {!t.readByAdmin && (
                                            <i className="fa-solid fa-envelope  text confirm">
                                                پیام جدید
                                            </i>
                                        )}
                                    </div>

                                    <div
                                        className={
                                            "status " +
                                                (t.status === "pending" &&
                                                    "text secondary") ||
                                            (t.status === "answered" &&
                                                "text primary")
                                        }
                                    >
                                        <i
                                            className={
                                                (t.status === "pending" &&
                                                    "fa-solid fa-spinner text secondary") ||
                                                (t.status === "answered" &&
                                                    "fa-solid fa-check text primary")
                                            }
                                        ></i>
                                        {(t.status === "pending" &&
                                            "در انتظار پاسخ") ||
                                            (t.status === "answered" &&
                                                "پاسخ داده شده")}
                                    </div>

                                    <a
                                        href={"" + t.id}
                                        className="respond text info"
                                    >
                                        <i className="fa-solid fa-eye text info"></i>
                                        مشاهده
                                    </a>
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    }
}

export default Tickets;
